import { hasValue } from '../helpers'
import { getApiClient } from './apiService'
import config from '../config/env'

const getAllCompanies = async ({
  page = 1,
  perPage = 16,
  search = '',
  city = null,
  type = null,
}) => {
  try {
    let url = `/companies-list?page=${page}&per_page=${perPage}`

    if (hasValue(search)) {
      url = `${url}&search=${search}`
    }

    if (city !== null) {
      url = `${url}&city=${city}`
    }
    if (type !== null) {
      url = `${url}&type=${type}`
    }

    if (config.DEBUG) {
      console.log('getCompanyProducts url: ', url)
    }

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getAllCompanies error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const checkIfCompanyExists = async ({ jib }) => {
  try {
    const response = await getApiClient().post(`/company-exists`, { jib })
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('checkIfCompanyExists error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const registerCompany = async data => {
  try {
    const response = await getApiClient().post('/companies', data)
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('registerCompany error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getMycompany = async () => {
  try {
    const response = await getApiClient().post('/companies/my-company')
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getMycompany error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const updateCompany = async ({ id, data }) => {
  try {
    const response = await getApiClient().put(`/companies/${id}`, data)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('updateCompany error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getCompanyInfo = async (companyId, shouldCount) => {
  try {
    const response = await getApiClient().get(
      `/companies/${companyId}?increment_views=${shouldCount}`,
    )
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getCompanyInfo error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getCompanyProducts = async ({
  companyId,
  page = 1,
  perPage = 12,
  search = '',
}) => {
  try {
    let url = `/companies/${companyId}/products?page=${page}&per_page=${perPage}`

    if (hasValue(search)) {
      url = `${url}&search=${search}`
    }

    if (config.DEBUG) {
      console.log('getCompanyProducts url: ', url)
    }

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getCompanyProducts error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getMyCompanyProducts = async ({
  page = 1,
  perPage = 12,
  search = '',
}) => {
  try {
    let url = `/companies/my-company-products?page=${page}&per_page=${perPage}`

    if (hasValue(search)) {
      url = `${url}&search=${search}`
    }

    if (config.DEBUG) {
      console.log('getCompanyProducts url: ', url)
    }

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getCompanyProducts error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getHomePageCompanies = async () => {
  console.log('home page companies called')
  try {
    let url = `/companies/promotions`

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getHomePageCompanies error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const searchCompanies = async name => {
  try {
    const response = await getApiClient().get(`/companies/search/${name}`)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('searchCompanies error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getAdminInfo = async () => {
  try {
    const response = await getApiClient().get('/data-for-admin')
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getAdminInfo error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const companyService = {
  getAllCompanies,
  registerCompany,
  checkIfCompanyExists,
  getMycompany,
  updateCompany,
  getCompanyInfo,
  getCompanyProducts,
  getMyCompanyProducts,
  getHomePageCompanies,
  searchCompanies,
  getAdminInfo,
}
